import { NgModule } from '@angular/core';
import { NoPreloading, RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from './components/not-found/not-found.component';

const routes: Routes = [
    { 
        path: '', 
        redirectTo: '/login',
        pathMatch: 'full' 
    },{
        path: 'login',
        loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
    },{
        path: 'index',
        loadChildren: () => import('./pages/index/index.module').then( m => m.IndexPageModule)
    },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            preloadingStrategy: NoPreloading
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
